import { useState, useCallback } from 'react';

import useAPI from "../../../../hooks/useAPI";

export const DOUBT_FILTERS = {
  SEARCH: 'search',
  TUTOR_ID: 'tutor_id',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  PRIORITY: 'priority',
  COURSE_ID: 'course_id',
  DOUBT_SEARCH: 'doubt_search',
  STATUS: 'status'
}

const buildDoubtURL = ({ baseURL, filters, page = 1, rowsPerPage = 50 }) => {
  const statusQuery = {
    1: {
      isPendente: 1
    },
    2: {
      isExpirada: 1
    },
    3: {
      isPendente: 0,
      isExpirada: 0
    }
  }

  const query = {
    ...(filters?.[DOUBT_FILTERS.SEARCH] && {search: filters[DOUBT_FILTERS.SEARCH]}),
    ...(filters?.[DOUBT_FILTERS.TUTOR_ID] && {idTutor: filters[DOUBT_FILTERS.TUTOR_ID]}),
    ...(filters?.[DOUBT_FILTERS.STATUS] && statusQuery[filters[DOUBT_FILTERS.STATUS]]),
    ...(filters?.[DOUBT_FILTERS.START_DATE] && {dateStart: filters[DOUBT_FILTERS.START_DATE]}),
    ...(filters?.[DOUBT_FILTERS.END_DATE] && {dateEnd: filters[DOUBT_FILTERS.END_DATE]}),
    ...(filters?.[DOUBT_FILTERS.PRIORITY] && {prioridade: filters[DOUBT_FILTERS.PRIORITY]}),
    ...(filters?.[DOUBT_FILTERS.DOUBT_SEARCH] && {doubtSearch: filters[DOUBT_FILTERS.DOUBT_SEARCH]}),
    ...(filters?.[DOUBT_FILTERS.COURSE_ID] && {idCurso: filters[DOUBT_FILTERS.COURSE_ID]}),
    page,
    limit: rowsPerPage
  }

  const urlSearchParams = new URLSearchParams(query);

  const urlQuery = urlSearchParams.size > 0 ? `?${urlSearchParams.toString()}` : '';

  return `${baseURL}${urlQuery}`;
}

export default function useDoubts() {
  const [filters, setFilters] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(1);

  const { data, isLoading, refreshData } = useAPI(buildDoubtURL({ baseURL: 'admin/operacoes/controle-tickets', filters, page, rowsPerPage }));
  
  const changePage = useCallback((page = 1) => {
    setPage(page);
  }, []);

  const changeRowsPerPage = useCallback((rowsPerPage = 50) => {
    setRowsPerPage(rowsPerPage);
  }, []);

  const changeFilters = useCallback((filters = {}) => {
    setFilters(prev => ({...prev, ...filters}));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({});
  }, []);

  return {
    data: data?.tickets,
    total: data?.total,
    page,
    rowsPerPage,
    filters,
    isLoading,
    changePage,
    changeRowsPerPage,
    changeFilters,
    clearFilters,
    refreshData
  }
}